import script from "./OtherNotesDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./OtherNotesDialog.vue?vue&type=script&lang=ts&setup=true"

import "./OtherNotesDialog.vue?vue&type=style&index=0&id=1892e677&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1892e677"]])

export default __exports__